import React from 'react';
import Link from 'next/link';
import getConfig from 'next/config';

import styles from './SocialShare.module.scss';

const { BASE_URL_MEDIA } = getConfig().publicRuntimeConfig;

interface SocialShareProps {
  title: string;
  slug: string;
  isV2?: boolean;
}

const BASE_URL = BASE_URL_MEDIA || 'https://lifepal.co.id/media/';

const SocialShare = (props: SocialShareProps) => {
  const { title, slug, isV2 } = props;
  const articleURL = `${BASE_URL}${slug}/`;

  const socialData = [
    {
      title: 'facebook',
      link: `https://www.facebook.com/sharer/sharer.php?u=${articleURL}`,
    },
    {
      title: 'twitter',
      link: `https://twitter.com/intent/tweet?text=${title}&url=${articleURL}`,
    },
    {
      title: 'linkedin',
      link: `https://www.linkedin.com/shareArticle?mini=true&url=${articleURL}`,
    },
    {
      title: 'whatsapp',
      link: `https://api.whatsapp.com/send?phone=&text=${title} ${articleURL}`,
    },
  ];

  return (
    <div className={isV2 ? styles['social-share__wrapper2'] : styles['social-share__wrapper']}>
      {isV2 && <p>Bagikan</p>}
      {socialData.map((data) => (
        <Link href={data.link} passHref={true} key={data.title}>
          <a
            target="_blank"
            rel="nofollow noopener noreferrer"
            title={`Share to ${data.title}`}
            className={styles[`${data.title}`]}
          >
            <div className={`iconSprites iconSprites-blue-${data.title}`} />
          </a>
        </Link>
      ))}
    </div>
  );
};

export default SocialShare;
